<template>
  <div class="container">
    <category-title :title="title" />
    <ServiceForm v-if="showForm" />
    <div v-else-if="showService" class="report-service">
      <div class="report-service__content">
        <div class="sub-title"><i class="icon-service"></i>服务须知</div>
        <div v-html="serviceContent"></div>
      </div>
      <div class="report-service__question">
        <div class="title">常见问题</div>
        <div class="content" v-html="questionContent"></div>
      </div>
      <div class="report__agree-btns">
        <van-button
          class="report__agree-btn"
          type="primary"
          size="small"
          :disabled="isDisableAgree"
          @click="onAgree"
        >
          同意{{ isDisableAgree ? countDownSec + 's' : '' }}
        </van-button>
        <van-button
          @click="onAgreeCancel"
          class="report__agree-btn"
          plain
          type="primary"
          size="small"
        >
          不同意
        </van-button>
      </div>
    </div>
    <div v-else>
      <category-list>
        <category-item title="线索征集" icon="xszj" @click="changeFormType('1')" />
        <category-item title="报警求助" icon="bjqz" @click="changeFormType('2')" />
        <category-item title="投诉举报" icon="tsjb" @click="changeFormType('3')" />
      </category-list>
      <category-title title="进度查询" />
      <progress-query />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onUnmounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { formData } from './helper/data';
import { getreport, reportinfo } from './helper/api';
import { Button as VanButton, Toast } from 'vant';

import CategoryTitle from './components/category/category-title.vue';
import CategoryList from './components/category/category-list.vue';
import CategoryItem from './components/category/category-item.vue';
import ProgressQuery from './components/progress.vue';
import ServiceForm from './components/service-form.vue';

const showForm = ref(false);
const showService = ref(false);
const isDisableAgree = ref(true);
const serviceContent = ref('');
const questionContent = ref('');
const countDownSec = ref(5);
const timer = ref(null);
const formType = ref();
const title = computed(() => {
  if (showForm.value) {
    return '服务表单';
  } else if (showService.value) {
    return '服务须知';
  } else {
    return '在线服务';
  }
});

const router = useRouter();
const route = useRoute();

onUnmounted(() => {
  if (timer.value) {
    clearInterval(timer.value);
  }
});

watch(
  () => route.query,
  query => {
    if (!query.formType) {
      resetStatus();
    }
  },
  { immediate: true, deep: true }
);

getServiceData();

function changeFormType(type) {
  showService.value = true;
  countDown({
    finish() {
      isDisableAgree.value = false;
    }
  });
  formType.value = Number(type);
}

function countDown(options) {
  timer.value = setInterval(() => {
    countDownSec.value--;
    if (countDownSec.value <= 0) {
      clearInterval(timer.value);
      options.finish && options.finish();
    }
  }, 1000);
}

function onAgree() {
  formData.source = formType.value;
  showForm.value = true;
  window.scrollTo({ top: 0 });
  router.push({ query: { formType: formType.value } });
}

function onAgreeCancel() {
  showForm.value = false;
  showService.value = false;
}

async function getServiceData() {
  try {
    const [{ list: serviceList }, { list: QuestionList }] = await Promise.all([
      getreport({ page: 1, size: 1, type: 101 }),
      getreport({ page: 1, size: 1, type: 102 })
    ]);
    const [{ content: res1 }, { content: res2 }] = await Promise.all([
      reportinfo(serviceList[0].id),
      reportinfo(QuestionList[0].id)
    ]);
    serviceContent.value = res1;
    questionContent.value = res2;
  } catch (error) {
    Toast.fail('获取服务信息失败');
  }
}

function resetStatus() {
  showForm.value = false;
  showService.value = false;
  countDownSec.value = 5;
  timer.value = null;
  isDisableAgree.value = true;
}
</script>

<style lang="scss">
@import './style/config';
.report__agree-btns {
  display: flex;
  justify-content: center;
  margin-top: 60px;
  .report__agree-btn {
    margin: 0 20px;
    min-width: 150px;
  }
}
.report-service {
  position: relative;
  font-size: 28px;
  line-height: 1.5;
  padding: 0 40px;
  .color-red {
    color: red;
  }
  .hl-block {
    background: #f3f3f3;
    padding: 20px;
    margin-top: 10px;
  }
  h3 {
    margin: 30px 0 20px;
  }
  p {
    margin: 10px 0;
  }
}

.report-service__content {
  .sub-title {
    color: #407bee;
    font-size: 30px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
  .icon-service {
    background: url('./imgs/icons/fuwu@2x.png') no-repeat left center;
    background-size: contain;
    width: 27px;
    height: 31px;
    margin-right: 10px;
  }
}

.report-service__question {
  position: absolute;
  top: 0;
  left: 100%;
  margin-left: 40px;
  border: 2px solid #85b1e4;
  width: 500px;

  .title {
    font-size: 32px;
    font-weight: bold;
    color: #407bee;
    padding: 20px 0;
    display: flex;
    justify-content: center;
    border-bottom: 2px solid #85b1e4;
  }
  .content {
    word-break: break-all;
    padding: 20px;
  }
}

@media screen and (max-width: 480px) {
  .report-service__question {
    position: unset;
    width: 100%;
    margin-left: 0;
    margin-top: 40px;
  }
}
</style>
